import { getEnvCode, useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";
import { env } from "../env";
import { SvgUser_outline } from "./svg";
import { useEffect } from "react";
import { useAuth } from "utils/hooks/useAuth";

export const LoginAzureAd: React.FC = () => {
  const { t } = useTranslation();
  const def_env = getEnvCode();
  const { language } = useTranslation();
  const url: string = `${env.api_url}/login/?env=${def_env}&lang=${language}&callbackurl=${window.location.origin}`
  const urlInterne: string = `${url}&interne=true`

  return <>
    <group
      data-position="fixed"
      data-bottom="0"
      data-right="40"
      data-width="auto"
      data-adaptive="desktop"
      data-index="3"
    >
      <div
        className="button secondary large outline fill"
        effect="material"
        onClick={() => {
          window.open(urlInterne, "_self")
        }}
      ><text className=""> {t("AZUREAD_CONNEXION_BUTTON")}</text></div>
    </group>
    <group
      data-position="fixed"
      data-bottom="0"
      //data-right="40"
      //data-width="auto"
      data-justify="center"
      data-adaptive="mobile"
      data-index="3"
    >
      <div
        className="button secondary large outline fill"
        effect="material"
        onClick={() => {
          window.open(urlInterne, "_self")
        }}
      ><text className=""> {t("AZUREAD_CONNEXION_BUTTON")}</text></div>
    </group>
  </>
}

export const LoginToolbar: React.FC = () => {
  const { t } = useTranslation();
  const def_env = getEnvCode();
  const { isNeuf, isEnvFr } = useSalesNetwork();
  const { language } = useTranslation();
  const { isAuth } = useAuth();
  const url: string = `${env.api_url}/login/?env=${def_env}&lang=${language}&callbackurl=${window.location.origin}`
  const urlInterne: string = `${url}&interne=true`

  useEffect(() => {
    if (!isAuth) {
      const atlantic_sso_user = document.cookie.split('; ').filter(row => row.startsWith('atlantic_sso_user=')).map(c => c.split('=')[1])[0]
      if (atlantic_sso_user) {
        window.location.href = url
      }
    }
  }, [])

  return (
    <>
      {!isAuth && <group
        data-justify="center"
        data-wrap="no"
        data-adaptive="mobile"
        data-height="70"
      >
        <div
          className="button large secondary noborder"
          data-fit="1"
          effect="material"
          data-height="auto"
          data-shrink="no"
          onClick={() => {
            window.open(isNeuf ? urlInterne : url, "_self")
          }}
        >
          <icon data-svg-size="24" data-svg-color="white"><SvgUser_outline /></icon>
          <text >{t("ATL_SSO_CONNEXION_BUTTON")}</text>
        </div>


        {isEnvFr && <>
          <div
            className="button secondary large outline fill noborder"
            data-fit="1"
            data-height="auto"
            effect="material"
            onClick={() => {
              window.open("https://accounts.groupe-atlantic.com/", "_self")
            }
            }>
            <text className="">{t("CREATE_YOUR_ACCOUNT")}</text>
          </div>

        </>}
      </group>
      }



    </>
  )
}

const LoginWidget: React.FC = () => {
  const { t } = useTranslation();
  const def_env = getEnvCode();
  const { isNeuf, isEnvFr } = useSalesNetwork();
  const { language } = useTranslation();
  const { isAuth } = useAuth();
  const url: string = `${env.api_url}/login/?env=${def_env}&lang=${language}&callbackurl=${window.location.origin}`
  const urlInterne: string = `${url}&interne=true`

  useEffect(() => {
    if (!isAuth) {
      const atlantic_sso_user = document.cookie.split('; ').filter(row => row.startsWith('atlantic_sso_user=')).map(c => c.split('=')[1])[0]
      if (atlantic_sso_user) {
        window.location.href = url
      }
    }
  }, [])

  return (
    <>
      {!isAuth &&
      <group
        data-gap="15"
        data-justify="center"
        data-wrap="no"
        data-space-right="15"
        data-adaptive="desktop"
      >


        <div
          className="button large"
          data-background="secondary"
          data-color="white"
          effect="material"
          data-shrink="no"
          onClick={() => {
            window.open(isNeuf ? urlInterne : url, "_self")
          }}
        >
          <icon data-svg-size="24" data-svg-color="white"><SvgUser_outline /></icon>
          <text data-adaptive="desktop-1000">{t("ATL_SSO_CONNEXION_BUTTON")}</text>
        </div>


        <group data-max-length="40" data-adaptive="desktop-1200"></group>

        {!isEnvFr && <><group
          data-cursor="pointer"
          data-align="center"
          data-justify="center"
          data-wrap="no"
          data-width="auto"
          data-interactive="highlight"
          data-text-align="center"
          data-border=""
        >
          <div
            className="button secondary large outline fill"
            effect="material"
            onClick={() => {
              window.open("https://accounts.groupe-atlantic.com/", "_self")
            }
            }>
            <text className="">{t("CREATE_YOUR_ACCOUNT")}</text>
          </div>
        </group>
          <group data-max-length="40" data-adaptive="desktop-1200"></group>
        </>}
      </group>

          }


    </>
  )
}

export default LoginWidget;